<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen w-full vx-row no-gutter items-center login-el flex justify-center">
    <logo-img></logo-img>
    <vs-row class="vs-row-login">
      <vs-col
        class="vs-col-col md-under-d-none"
        vs-type="flex"
        vs-justify="center"
        vs-w="8"
      >
        <div class="login-left">
          <img class="logo-left-bg" src="../assets/images/loginbg.png" alt="">
        </div>
      </vs-col>
      <vs-col
        class="vs-col-col login-right-col vs-md-12 vs-xs-12 vs-sm-12"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="4"
        vs-sm="12"
        vs-xs="12"
      >
        <div class="login-right">
          <h3 class="title">欢迎使用PMS系统</h3>
          <p class="tips">请登录</p>
          <form>
            <vs-input
              label="用户名"
              placeholder="用户名"
              v-model="username"
              name="username"
              class="w-full"/>
            <!--            todo 点击眼睛效果-->
            <div class="password-box">
              <vs-input
                type="password"
                name="password"
                label="密码"
                placeholder="密码"
                v-model="password"
                class="w-full mt-6" />
            </div>
            <vs-input
              label="动态密码"
              placeholder="动态密码"
              v-model="dynamicPassword"
              class="w-full mt-6"
              @keyup.enter="loginHandle"
            ></vs-input>
            <vs-button
              class="w-full mt-6"
              color="primary"
              type="filled"
              @click="loginHandle"
            >登录</vs-button>
          </form>
          <vs-divider/>
          <div class="site-info display-flex justify-center">
            <span>COPYRIGHT &copy; {{ new Date().getFullYear() }}Huanchu</span>
          </div>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
  import MD5 from 'js-md5'
  import { login } from '@/api/user'
  import Logo from '@/layouts/components/Logo'
export default{
    components:{
      Logo
    },
  data() {
    return {
      username: '',
      password: '',
      dynamicPassword: '',
    }
  },
  methods: {
    loginHandle(){
      if(!this.username || !this.password || !this.dynamicPassword){
        return;
      }
      login({
          userName: this.username,
          password: MD5(this.password),
          googleKey: this.dynamicPassword,
        }).then((res) => {
        localStorage.setItem('token',res.data.token);
        this.$router.push({name: 'home'});
      })
    },
  },
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
  .login-el {
    background-color: #F8F8F8;
    .login-left {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .logo-left-bg {
        width: 70%;
      }


    }
    .vs-row-login,
    .vs-col-col {
      height: 100%;
    }
  }
.logo-el {
  position: fixed;
  top: 20px;
  left: 20px;
}
  .login-right {
    width: 100%;
    padding: 0 2.28rem;
    .tips {
      margin-bottom: 30px;
    }
  }
  .login-right-col {
    background-color: #ffffff;
  }
@media screen and (min-width: 900px) and (max-width: 992px) {
  .login-right-col {
    width: 100%!important;
  }
}
</style>
